<template>
  <div>

      <h5>試弾申し込み一覧</h5>
      <hr>

      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th style="min-width: 150px;">申し込み日</th>
              <th style="min-width: 150px;">写真</th>
              <th style="min-width: 150px;">商品のタイトル</th>
              <th style="min-width: 150px;">販売者</th>
              <th style="min-width: 120px;">ステータス</th>
              <th style="min-width: 120px;">メッセージ</th>
            </tr>
            <tr v-for="(order, index) in allGetOrders">
              <td>
                {{ date_only_format(order['created_at']) }}
              </td>
              <td style="max-width: 150px;" @click="jumpProductDetail(order['products_id'])">
                <img class="" :src="order['image1']" style="width: 100%;height: auto;">
              </td>
              <td @click="jumpProductDetail(order['products_id'])">
                {{ order['title'] }}
              </td>
              <td @click="jumpSeller(order['sellers_id'])">
                <strong v-if="order['legal_person']==1">{{ cinit(order['corp_name'], '-') }}</strong>
                <strong v-else-if="order['legal_person']==0">{{ cinit(order['store_name'], '-') }}</strong>
                <span>{{ order['last_name'] + ' ' + order['first_name'] }}</span>
              </td>
              <td>
                {{ get_hash_value(status, order['status']) }}
              </td>
              <td>
                <button class="btn btn-info" @click="jumpMessageDetail(order['messages_id'], order['sellers_id'])">返信</button>
              </td>
            </tr>
          </table>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
		const status = [
			{"no":"0","name":"申し込み"},
			{"no":"2","name":"完了"},
			{"no":"9","name":"キャンセル"},
    ];
    return {
      status,
      orders: [],
    }
  },
	methods: {
	  jumpSeller(id) {
        this.$router.push({path: '/seller/'+String(id)});
	  },
    jumpProductDetail: function(id){
        this.$router.push({path: '/product/'+String(id)});
	  },
	  jumpMessageDetail: function(id, users_id){
        this.$router.push({path: '/message/'+String(users_id)+'/'+String("1")+'/'+String(id)});
	  },
	  async get_order() {
		  this.$store.dispatch('order/get_test_bullet', {}).then(res => {
		    console.log(res);
		    let ret = res.data.orders;
		    this.orders = ret['orders'];
		    console.log(this.orders);
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	created() {
		this.get_order();
	},
	computed: {
		allGetOrders: function() {
			return this.orders;
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/buyer/test_bullet.vue